<template>
  <div class="card flex-row flex-wrap" :class="[ isCardList ? 'list' : '' ]" @click="$emit('click')">
    <div class="card-header border-0">
      <img :src="courseProfileImage" alt="publisher-profile">
    </div>
    <div class="card-block px-2">
      <div class="card-title">{{ courseTitle }}</div>
      <div class="card-text">{{ courseOwnerName }}</div>
      <div class="card-text">{{ courseGrade }} {{ courseSubjectName }}</div>
      <div class="card-text">{{ isVideoCourse ? '강의수' : '참고서' }} {{ courseLectureCount || 0 }}</div>
    </div>
    <div class="card-action" v-if="false">
      <img :src="`/static/images/${subscriptionResources().icon}`" class="icon" />
      <span :style="{ 'color': subscriptionResources().color }">구독</span>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { find } from 'lodash';
  import labels from '@/mixins/labels';

  export default {
    name: 'course-card',

    mixins: [
      labels,
    ],

    props: {
      course: {
        type: Object,
      },
      isCardList: {
        type: Boolean,
        default: false,
      },
      isSubscription: {
        type: Boolean,
        default: false,
      },
      isVideoCourse: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      ...mapGetters({
        subjectMap: 'getSubjectMap',
        gradeMap: 'getGradeMap',
      }),

      courseTitle() {
        return this.course.title || this.course.name;
      },

      courseOwner() {
        return this.course.owner;
      },

      courseOwnerName() {
        return this.courseOwner.name;
      },

      courseProfileImage() {
        if (!this.courseOwner.profile_image) {
          return '/static/images/user_profile.png';
        }

        return this.courseOwner.profile_image;
      },

      filterSubject() {
        return find(this.subjectMap, { id: this.course.subject_id }) || {};
      },

      courseSubjectName() {
        return this.filterSubject.name;
      },

      courseGrade() {
        return this.getTranslatedName(this.gradeMap[this.course.grade_id]);
      },

      courseLectureCount() {
        return this.course.lecture_count;
      },
    },

    methods: {
      subscriptionResources() {
        if (this.isSubscription) {
          return {
            icon: 'ic-checked2.svg',
            color: '#ff595f',
            name: '구독중',
          };
        }

        return {
          icon: 'ic-check.svg',
          color: '#bcbbbb',
          name: '구독하기',
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  .card {
    border: none;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    width: 100%;
    cursor: pointer;

    &:hover {
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.3);
    }

    .card-header {
      background-color: #ffffff;
      padding: 14px;

      img {
        width: 44px;
        height: 44px;
        object-fit: cover;
      }
    }

    .card-block {
      font-size: 14px;
      padding: 14px;
      position: relative;

      .card-title {
        font-size: 16px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-inline-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        max-height: 40px;
        word-break: break-all;
        white-space: normal;
      }

      .card-text {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.38);
        padding: 0 0 4px 0; 
      }
    }

    .card-action {
      position: absolute;
      bottom: 14px;
      right: 14px;

      .icon {
        margin: 0 6px;
      }
    }
  }

  .list {

    .card-header {
      background-color: #ffffff;
    }

    .card-block {
      width: 50%;

      .card-title {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-inline-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        max-height: 40px;
        word-break: break-all;
        white-space: normal;
      }
    }
  }

</style>


// WEBPACK FOOTER //
// CourseCard.vue?0c85332d